//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';
import { has } from "lodash"

//  -- Actions ------------------------
import * as pastSubmissionsActions from './actions';
import * as SubmissionsActions from '../submissions/actions';
import { logToSentry } from "utils/networkErrorUtils";
import { clearAssignmentTrackingLocalForAssignment } from 'utils/assignmentSessionTracking';

//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- Create submission --------------

export const handleCreatePastSubmission = (data) => async (dispatch, getState) => {
    try {
    const submission_data =  await apis.post('pastSubmission', `/pastSubmissions`, {
            body: data
        });
        if(has(submission_data,"past_submission")){
            const submission = submission_data.submission;
            if (submission?.assignmentId && submission?.userId && submission?.classId) {
                clearAssignmentTrackingLocalForAssignment(
                    submission.assignmentId,
                    submission.userId,
                    submission.classId
                );
            }
            await dispatch(pastSubmissionsActions.updatePastSubmissions(submission_data.past_submission))
            const existing = getState()?.submissions?.find((s) => s?.id === submission?.id);
            const prevMeta =
                existing?.meta_data && typeof existing.meta_data === 'object' && !Array.isArray(existing.meta_data)
                    ? existing.meta_data
                    : {};
            await dispatch(
                SubmissionsActions.updateSubmissionSuccess({
                    ...submission,
                    meta_data: { ...prevMeta, session_replays: [] },
                })
            );
        }
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'creating past submission',
                error,
                module: 'PAST_SUBMISSION',
                operation: 'CREATE_PAST_SUBMISSION'
            });
         }
        return error
    }
};






